import React from 'react'
import {BsInfoCircle} from "react-icons/bs";
import useTranslate from "../../modules/local/useTranslate";
import {renderIfElse} from "../../views/Shared";
import {GiPlainCircle} from "react-icons/gi";

const HeaderGroupItem = ({
    style,
    title,
    children,
    className,
    renderTitle,
    divider = true,
    hidden = false,
    size = 'small',
}) => {

    const t = useTranslate()

    if (Boolean(hidden)) return null

    return (
        renderIfElse(
            size === 'small',
            <div className="flex items-center gap-2 mt-3">
                <GiPlainCircle size={7} className="text-color-400" />
                <span className="font-medium text-sm text-color-300 tracking-wide">
                    {renderTitle ? renderTitle(t) : t(title)}
                </span>
            </div>,
            <div className="w-full flex flex-col mt-3">
                <div className="flex items-center justify-center gap-3">
                    <BsInfoCircle size={16} className="text-color-400"/>
                    <span className="uppercase text-xl font-bold text-color-200 tracking-wide">
                        {renderTitle ? renderTitle(t) : t(title)}
                    </span>
                    {!!divider && <span className="border-b w-full flex-1"/>}
                </div>
            </div>
        )
    )
}

export default HeaderGroupItem
